import React, {ReactNode} from 'react';

import cn from 'classnames';

import styles from './MainModal.module.scss';

interface IModalBodyWrapperProps {
    children: ReactNode,
    className?: string;
}

const ModalBodyWrapper: React.FC<IModalBodyWrapperProps> = ({children, className}) => {
    return (
        <div className={cn(styles.wrapper, className)}>
            {children}
        </div>
    );
};

export default ModalBodyWrapper;